<div class="main p-4" style="position: relative; z-index: 1; overflow-x: hidden;">
    <div class="container-fluid">
        <div class="box-title mb-4">
            <h5 class="fw-bold">{{"DCO.title_Dashboard" | translate}}</h5>
            <p class="text-muted">{{"DCO.Dashboard_PageDescription" | translate}}</p>
        </div>
        <div class="card shadow-sm border-0 p-4 mb-4">
            <!-- Títulos de la sección -->
            <div class="mb-3">
                <h5 class="text-primary fw-bold mb-1">{{"DCO.Dashboard_Statistics" | translate}}</h5>
                <p class="text-muted small mb-4">{{"DCO.Dashboard_DescriptionByYear" | translate}}</p>
                <hr class="mt-0 mb-0" style="opacity: 0.1; border-top: 1px solid #666;">
            </div>
            <div class="row g-3 mb-4">
                <div class="col-md-3">
                    <div class="card shadow-sm border-0 border-start border-primary border-4 p-2"
                        style="background-color: rgba(47, 187, 238, 0.05); min-height: 80px;">
                        <div style="position: absolute; left: 65px; top: 28px; z-index: 10;">
                            <span class="fw-bold text-dark" style="font-size: 14px;">
                                {{"DCO.Dashboard_TotalDisputes" | translate}}
                            </span>
                        </div>
                        <div id="chartTotal"></div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card shadow-sm border-0 border-start border-info border-4 p-2"
                        style="background-color: rgba(76, 163, 198, 0.05); min-height: 80px;">
                        <div style="position: absolute; left: 65px; top: 28px; z-index: 10;">
                            <span class="fw-bold text-dark" style="font-size: 14px;">
                                {{"DCO.Dashboard_AverageByMonth" | translate}}
                            </span>
                        </div>
                        <div id="chartMedia"></div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card shadow-sm border-0 border-start border-success border-4 p-2"
                        style="background-color: rgba(0, 180, 72, 0.05); min-height: 80px;">
                        <div style="position: absolute; left: 65px; top: 28px; z-index: 10;">
                            <span class="fw-bold text-dark" style="font-size: 14px;">
                                {{"DCO.Dashboard_AverageSuccess" | translate}}
                            </span>
                        </div>
                        <div id="chartExito"></div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card shadow-sm border-0 border-start border-warning border-4 p-2"
                        style="background-color: rgba(244, 191, 15, 0.05); min-height: 80px;">
                        <div style="position: absolute; left: 65px; top: 28px; z-index: 10;">
                            <span class="fw-bold text-dark" style="font-size: 14px;">
                                {{"DCO.Dashboard_AverageAmount" | translate}}
                            </span>
                        </div>
                        <div id="chartImporte"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row g-4 align-items-stretch">
            <div class="col-md-7 d-flex">
                <div class="card shadow-sm p-4 border-0 rounded-4 w-100 d-flex flex-column h-100">
                    <div class="d-flex justify-content-between align-items-center mb-4">
                        <h5 class="text-primary fw-bold mb-0">{{"DCO.Dashboard_DisputesByState" | translate}}</h5>
                    </div>
                    <div class="row g-3 mb-4 align-items-end">
                        <div class="col-md-3">
                            <label class="small text-muted mb-1" style="margin-right: 4px">{{"DCO.Dashboard_From" |
                                translate}}</label>

                            <input type="date" class="form-control form-control-sm border-0 bg-light shadow-none" [min]="minDate"
                                [max]="maxDate" style="display:inline-block; width:150px;" [(ngModel)]="dateFrom"
                                (change)="onGroupingChange()">
                        </div>
                        <div class="col-md-3">
                            <label class="small text-muted mb-1" style="margin-right: 4px">{{"DCO.Dashboard_To" |
                                translate}}</label>


                            <input type="date" class="form-control form-control-sm border-0 bg-light shadow-none" [min]="minDate"
                                [max]="maxDate" style="display:inline-block; width:150px; " [(ngModel)]="dateTo"
                                (change)="onGroupingChange()">
                        </div>
                        <div class="col-md-4">
                            <label class="small text-muted mb-1" style="margin-right: 4px">{{"DCO.Dashboard_GroupBy" |
                                translate}}</label>

                            <select class="form-select form-select-sm border-0 bg-light shadow-none"
                                style="display:inline-block; width:150px; " [(ngModel)]="selectedGrouping"
                                (change)="onGroupingChange()">
                                <option [value]="0">{{"DCO.Dashboard_ByWeek" | translate}}</option>
                                <option [value]="1">{{"DCO.Dashboard_ByMonth" | translate}}</option>
                                <option [value]="2">{{"DCO.Dashboard_ByYear" | translate}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="position-relative flex-grow-1">
                        <div id="chartStackedContainer"></div>
                        <div id="chartStackedContainerTooltip" class="custom-tooltip-d3"></div>
                    </div>
                </div>
            </div>
            <div class="col-md-5 d-flex">
                <div class="card shadow-sm p-4 border-0 rounded-4 w-100 d-flex flex-column h-100">
                    <h5 class="text-primary fw-bold mb-1">{{"DCO.Dashboard_Pie_DisputesByReasons" | translate}}</h5>
                    <p class="text-muted small mb-4">{{"DCO.Dashboard_DescriptionByYear" | translate}}</p>
                    <hr class="mt-0 mb-0" style="opacity: 0.1; border-top: 1px solid #666;">

                    <div class="position-relative d-flex justify-content-center align-items-center flex-grow-1"
                        style="overflow: hidden;">
                        <div id="chartPieContainer" class="DashboardBody" style="width: 100%;"></div>
                        <div id="chartPieContainerTooltip" class="custom-tooltip-d3"></div>
                    </div>
                </div>
            </div>
        </div>
        <br>
        <div class="row g-4 align-items-stretch">
            <div class="col-md-7">
                <div class="card shadow-sm p-4 border-0 rounded-4 w-100 d-flex flex-column">
                    <div class="d-flex justify-content-between align-items-center mb-4">
                        <h5 class="text-primary fw-bold mb-0">{{"DCO.Dashboard_DisputesByReasons" | translate}}</h5>
                    </div>
                    <div class="row g-3 mb-4 align-items-end">
                        <div class="col-md-3">
                            <label class="small text-muted mb-1" style="margin-right: 4px">{{"DCO.Dashboard_From" |
                                translate}}</label>
                            <input type="date" class="form-control form-control-sm border-0 bg-light shadow-none"
                                style="display:inline-block; width:150px;" [(ngModel)]="dateFrom" [min]="minDate"
                                [max]="maxDate" (change)="onGroupingReasonsChange()">
                        </div>
                        <div class="col-md-3">
                            <label class="small text-muted mb-1" style="margin-right: 4px">{{"DCO.Dashboard_To" |
                                translate}}</label>
                            <input type="date" class="form-control form-control-sm border-0 bg-light shadow-none"
                                style="display:inline-block; width:150px;" [(ngModel)]="dateTo" [min]="minDate"
                                [max]="maxDate" (change)="onGroupingReasonsChange()">
                        </div>
                        <div class="col-md-4">
                            <label class="small text-muted mb-1" style="margin-right: 4px">{{"DCO.Dashboard_GroupBy" |
                                translate}}</label>
                            <select class="form-select form-select-sm border-0 bg-light shadow-none"
                                style="display:inline-block; width:150px;" [(ngModel)]="selectedGroupingReasons"
                                (change)="onGroupingReasonsChange()">
                                <option [value]="0">{{"DCO.Dashboard_ByWeek" | translate}}</option>
                                <option [value]="1">{{"DCO.Dashboard_ByMonth" | translate}}</option>
                                <option [value]="2">{{"DCO.Dashboard_ByYear" | translate}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="position-relative">
                        <div id="chartStackedReasonContainer"></div>
                        <div id="chartStackedReasonContainerTooltip" class="custom-tooltip-d3"></div>
                    </div>
                </div>
            </div>
            <div class="col-md-5 d-flex">
                <div class="card shadow-sm p-4 border-0 rounded-4 w-100 d-flex flex-column">
                    <h5 class="text-primary fw-bold mb-1">{{"DCO.Dashboard_DisputesByCommerce" | translate}}</h5>
                    <p class="text-muted small mb-4">{{"DCO.Dashboard_DescriptionByYear" | translate}}</p>
                    <hr class="mt-0 mb-0" style="opacity: 0.1; border-top: 1px solid #666;">

                    <div class="position-relative d-flex justify-content-center align-items-center flex-grow-1"
                        style="overflow: hidden;">
                        <div id="chartlandscapeContainer" style="width: 100%;"></div>
                        <div id="chartlandscapeContainerTooltip" class="custom-tooltip-d3"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>